module.exports = __webpack_public_path__ + "img/daycare_thumbnail.1b0b0298.jpg";